/**
 * Dev-only logger. Silent in production so we never leak internal state
 * (API status codes, error names, etc.) to end users' consoles.
 *
 * Usage: `logWarn("[player] play() rejected", err?.name);`
 */
const IS_DEV = process.env.NODE_ENV !== "production";

export const logWarn = IS_DEV ? console.warn.bind(console) : () => {};
export const logInfo = IS_DEV ? console.info.bind(console) : () => {};
export const logError = IS_DEV ? console.error.bind(console) : () => {};
